module.exports = __webpack_public_path__ + "static/media/invite-user-icon.888fadb3.svg";